var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchCheckUnchecked3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 969.4 999",
    style: {
      enableBackground: "new 0 0 969.4 999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443,999c-59.8,0-117.8-11.7-172.5-34.8c-52.8-22.3-100.1-54.3-140.8-94.9c-40.7-40.7-72.6-88-94.9-140.8 C11.7,673.8,0,615.8,0,556c0-59.8,11.7-117.8,34.8-172.4c22.3-52.8,54.3-100.1,94.9-140.8c40.7-40.7,88-72.6,140.8-94.9 C325.2,124.7,383.2,113,443,113c59.8,0,117.8,11.7,172.4,34.8c52.8,22.3,100.1,54.2,140.8,94.9c40.7,40.7,72.6,88,94.9,140.8 C874.3,438.2,886,496.2,886,556c0,59.8-11.7,117.8-34.8,172.5c-22.3,52.8-54.3,100.1-94.9,140.8c-40.7,40.7-88,72.6-140.8,94.9 C560.8,987.3,502.8,999,443,999z M443,203c-94.3,0-182.9,36.7-249.6,103.4C126.7,373.1,90,461.7,90,556 c0,94.3,36.7,182.9,103.4,249.6C260.1,872.3,348.7,909,443,909c94.3,0,182.9-36.7,249.6-103.4C759.3,738.9,796,650.3,796,556 c0-94.3-36.7-182.9-103.4-249.6C625.9,239.7,537.3,203,443,203z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchCheckUnchecked3);
export default __webpack_public_path__ + "static/media/ach_check-unchecked-3.18a0aecf1f965ea272082b437b66400b.svg";
export { ForwardRef as ReactComponent };